import { render, staticRenderFns } from "./yz-input.vue?vue&type=template&id=5b339eef&scoped=true&"
import script from "./yz-input.vue?vue&type=script&lang=js&"
export * from "./yz-input.vue?vue&type=script&lang=js&"
import style0 from "./yz-input.vue?vue&type=style&index=0&id=5b339eef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b339eef",
  null
  
)

export default component.exports